
function TagColorSelector(tagName) {

  if(tagName === "grass")
    return "#25b845"
  else if(tagName === "fire")
    return "#f16835"
  else if(tagName === "electric")
    return "#d0d73d"
  else if(tagName === "ground")
    return "#947852"
  else if(tagName === "rock")
    return "#d2af5a"
  else if(tagName === "fairy")
    return "#ef8ada"
  else if(tagName === "water")
    return "#28aeb2"
  else if(tagName === "flying")
    return "#4e82c6"
  else if(tagName === "bug")
    return "#9dab2a"
  else if(tagName === "poison")
    return "#a62a28"
  else if(tagName === "fighting")
    return "#aa2cbe"
  else if(tagName === "psychic")
    return "#9f3060"
  else if(tagName === "steel")
    return "#828588"
  else if(tagName === "ice")
    return "#42e1ef"
  else if(tagName === "ghost")
    return "#000000"
  else if(tagName === "dragon")
    return "#2b7b00"
  else 
    return "#0098f2"
}

export default TagColorSelector